package com.arena_web.ui.components.widgets

import androidx.compose.runtime.*
import com.arena_web.ui.theme.AppColors
import com.arena_web.ui.theme.AppTypography
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.w3c.dom.ScrollBehavior
import org.w3c.dom.ScrollToOptions

val FadeInKeyframes = Keyframes {
    0.percent {
        Modifier.opacity(0).scale(0.8)
    }
    100.percent {
        Modifier.opacity(1).scale(1)
    }
}

val BackToTopButtonStyle = CssStyle {
    base {
        Modifier
            .sSize(56)
            .borderRadius(50.percent)
            .cursor(Cursor.Pointer)
            .transition(
                Transition.of("transform", Constants.ANIMATION_FAST.ms),
                Transition.of("box-shadow", Constants.ANIMATION_FAST.ms)
            )
            .styleModifier {
                property("pointer-events", "auto")
            }
    }
    hover {
        Modifier
            .styleModifier {
                property("transform", "translateY(${s(-8)})")
                property("box-shadow", "0 8px 24px rgba(0, 0, 0, 0.3)")
            }
    }
}

val ArrowStyle = CssStyle.base {
    Modifier
        .fontFamily(AppTypography.SECONDARY_FONT_NAME, AppTypography.SECONDARY_FONT_FALLBACK)
        .fontWeight(FontWeight.Bold)
        .sFontSize(24)
}

@Composable
fun BackToTopButton() {
    var scrollPosition by remember { mutableStateOf(0.0) }

    DisposableEffect(Unit) {
        val listener: (dynamic) -> Unit = {
            scrollPosition = document.documentElement?.scrollTop ?: 0.0
        }
        window.addEventListener("scroll", listener)
        onDispose {
            window.removeEventListener("scroll", listener)
        }
    }

    val isVisible = scrollPosition > Constants.SCROLL_THRESHOLD

    Column(
        modifier = Modifier
            .fillMaxSize()
            .position(Position.Fixed)
            .zIndex(100)
            .pointerEvents(PointerEvents.None),
        verticalArrangement = Arrangement.Bottom,
        horizontalAlignment = Alignment.End
    ) {
        val colorMode = ColorMode.current
        val colors = AppColors.getColors(colorMode)

        val buttonColor = colors.onSurface
        val arrowColor = colors.background

        Box(
            modifier = BackToTopButtonStyle
                .toModifier()
                .sMarginRight(32)
                .sMarginBottom(32)
                .backgroundColor(buttonColor)
                .visibility(if (isVisible) Visibility.Visible else Visibility.Hidden)
                .onClick {
                    kotlinx.browser.window.scrollTo(
                        x = 0.0,
                        y = 0.0
                    )
                    document.documentElement?.scrollTop = 0.0
                }
                .then(
                    if (isVisible) {
                        Modifier.animation(
                            FadeInKeyframes.toAnimation(
                                duration = Constants.ANIMATION_NORMAL.ms,
                                timingFunction = AnimationTimingFunction.EaseOut
                            )
                        )
                    } else {
                        Modifier
                    }
                ),
            contentAlignment = Alignment.Center
        ) {
            SpanText(
                text = "\u2191",
                modifier = ArrowStyle
                    .toModifier()
                    .color(arrowColor)
            )
        }
    }
}
